/**
 * Fascia 5 Blocchi — accordion interaction
 * Clicking a collapsed item expands it and collapses the previously active one.
 */

document.querySelectorAll('[data-fascia-5-blocchi]').forEach((container) => {
  const items = container.querySelectorAll('.fascia-5-blocchi__item');

  items.forEach((item) => {
    item.addEventListener('click', () => {
      if (item.classList.contains('fascia-5-blocchi__item--active')) return;

      items.forEach((el) => el.classList.remove('fascia-5-blocchi__item--active'));
      item.classList.add('fascia-5-blocchi__item--active');
    });
  });
});
